var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getPost)?_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card mb-2"},[_c('proj-header'),_vm._v(" "),_c('proj-body',{attrs:{"item":_vm.getPost}})],1)])]):_c('not-found-msg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }